export const BREAKPOINTS = {
  mobile: 1083,
  chartMobile: 767,
  sm: 600,
  md: 900,
  lg: 1300,
  xl: 1440,
  xxl: 1920,
};

const max = (px: number): string => `(max-width: ${px}px)`;
const min = (px: number): string => `(min-width: ${px}px)`;

export const media = {
  maxMobile: max(BREAKPOINTS.mobile),
  maxChartMobile: max(BREAKPOINTS.chartMobile),
  maxSm: max(BREAKPOINTS.sm),
  maxMd: max(BREAKPOINTS.md),
  maxLg: max(BREAKPOINTS.lg),
  maxXl: max(BREAKPOINTS.xl),
  maxXxl: max(BREAKPOINTS.xxl),

  minMobile: min(BREAKPOINTS.mobile),
  minChartMobile: max(BREAKPOINTS.chartMobile),
  minSm: min(BREAKPOINTS.sm),
  minMd: min(BREAKPOINTS.md),
  minLg: min(BREAKPOINTS.lg),
  minXl: min(BREAKPOINTS.xl),
  minXxl: min(BREAKPOINTS.xxl),

  between: (minPx: number, maxPx: number) => `(min-width: ${minPx}px) and (max-width: ${maxPx}px)`,
};
